import React, { Component } from "react";
import { connect } from "react-redux";
import { SecondaryButton, PrimaryButton } from "components/Global/Buttons";
import CloseIcon from "lib/ui/close";
import { Dialog, DialogContent, DialogTitle, DialogActions, Button } from "@material-ui/core";
import { getHedge } from "store/state/hedge";
import { SideLabelDecimalInput, SideLabelMoneyInput, SideLabelPercentInput, SideLabelIntegerInput } from "./FormSectionComponents";
import { Formik } from 'formik';
import hedgeTypes from "constants/hedgeTypes";
import hedgeStatus from "constants/hedgeStatus";
import daycounts from "constants/daycounts";
import ratingTriggers from "constants/ratingTriggers";

const ACTIONS = {
  CANCEL: 'CANCEL'
  , CREATE_ESCROW_CAP: 'CREATE_ESCROW_CAP'
};

class EscrowCapModal extends Component {
  state = {
    action: null,
    errors: {}
  }

  constructor(props) {
    super(props);
    this.formik = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    const { action } = this.state;

    // only do something if isLoading has changed from true to false
    if (action && prevState.action !== action) {
      const switchKey = action;

      switch (switchKey) {
        case ACTIONS.CREATE_ESCROW_CAP:
          this.formik.current.handleSubmit();
          this.setAction(null);
          break;

        case ACTIONS.CANCEL:
          this.setAction(null);
          this.props.handleClose();
          break;
      }
    }
  }

  getUpdatedHedgeDetail = (values) => {
    const { hedgeDetail } = this.props;
    return {
      ...hedgeDetail
      , ...values
      , strike: values.strike / 100
    };
  }

  setAction = (action) => this.setState({ action });

  // a lot of these input validations do not work currently, was told to skip in hopes that redesign will take care of it.
  renderForm = ({ values, setFieldValue, errors }) => {
    return (
      <div style={{ minWidth: 500 }}>
        <SideLabelMoneyInput label="Notional" fieldName="notional" name="notional" />
        <SideLabelPercentInput label="Strike" fieldName="strike" name="strike" decimalScale={2} />
        <SideLabelIntegerInput label="Term(m)" fieldName="escrowTerm" name="escrowTerm" />

        <br />

        <SideLabelIntegerInput label="Repricing Interval(m)" fieldName="repricingInterval" name="repricingInterval" />
        <SideLabelDecimalInput label="Pricing Inflator" fieldName="pricingInflator" name="pricingInflator" decimalScale={2} />
        <SideLabelMoneyInput label="Broker Fee" fieldName="brokerFee" name="brokerFee" />
        <SideLabelMoneyInput label="Begining Escrow Balance" fieldName="beginningEscrowBalance" name="beginningEscrowBalance" />
      </div>
    )
  }

  getInitialValue = (hedgeDetail) => {
    return {
      id: null
      , notional: hedgeDetail && hedgeDetail.notional || null
      , strike: hedgeDetail && hedgeDetail.strike || null
      , escrowTerm: hedgeDetail && hedgeDetail.escrowTerm || null
      , repricingInterval: hedgeDetail && hedgeDetail.repricingInterval || 6
      , pricingInflator: hedgeDetail && hedgeDetail.pricingInflator || 1.25
      , brokerFee: hedgeDetail && hedgeDetail.brokerFee || '0'
      , beginningEscrowBalance: hedgeDetail && hedgeDetail.beginningEscrowBalance || '0'
      
      // defaults so we can calc things
      , replacingHedgeId: hedgeDetail && hedgeDetail.id || null
      , isEscrowCalc: hedgeDetail && hedgeDetail.isEscrowCalc || true
      , escrowStart: hedgeDetail && hedgeDetail.effectiveDate || null
      , escrowEnd: hedgeDetail && hedgeDetail.terminationDate || null
      , hedgeStatusId: hedgeStatus.WATCH
      , hedgeTypeId: hedgeTypes.CAP
      , daycountId: daycounts.ACTUAL_OVER_360
      , ratingsTriggerId: ratingTriggers.map.FREDDIE_MAC
    };
  }

  onValidate = (values) => {
    const errors = {
      notional: !values.notional ? 'Required' : undefined
      , strike: !values.strike ? 'Required' : undefined
      , escrowTerm: !values.escrowTerm ? 'Required' : undefined
      , repricingInterval: !values.repricingInterval ? 'Required' : undefined
      , pricingInflator: !values.pricingInflator ? 'Required' : undefined
      , brokerFee: !values.brokerFee ? 'Required' : undefined
      , beginningEscrowBalance: !values.beginningEscrowBalance ? 'Required' : undefined
    };

    const isNotValid = Object.values(errors).some(x => x !== undefined);
    return isNotValid ? errors : undefined;
  };

  onSubmit = (values) => {
    const hedge = this.getUpdatedHedgeDetail(values);
    this.props.handleClose(false, hedge);
  }

  render() {
    const { isOpen, hedgeDetail, saveButtonText } = this.props;
    const initialValues = this.getInitialValue(hedgeDetail);

    return (
      <Dialog
        modal='true'
        maxWidth="md"
        open={isOpen}
      >
        <div style={{ display: 'flex' }}>
          <DialogTitle>Add Escrow Cap</DialogTitle>
          <Button onClick={() => this.setAction(ACTIONS.CANCEL)} style={{ marginLeft: 'auto' }}>
            <CloseIcon />
          </Button>
        </div>

        <DialogContent style={{ maxHeight: "500px", overflow: "auto" }}>
          <Formik
            ref={this.formik}
            render={this.renderForm}
            initialValues={initialValues}
            validate={this.onValidate}
            onSubmit={this.onSubmit}
          />
        </DialogContent>

        <DialogActions>
          <SecondaryButton onClick={() => this.setAction(ACTIONS.CANCEL)} style={{ marginRight: 'auto' }}>
            CANCEL
          </SecondaryButton>

          <PrimaryButton onClick={() => this.setAction(ACTIONS.CREATE_ESCROW_CAP)}>
            {saveButtonText || 'SAVE'}
          </PrimaryButton>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = ({ hedge }) => ({
  hedgeDetail: hedge.hedgeDetail.details
});

export default connect(mapStateToProps, {
  getHedge
})((EscrowCapModal));
